import { useApiOriginacao } from "./base/useApiOriginacao";

export type IApiClientThemeResponse = {
  digitacao: {
    titulo: string;
    titulo_cartao: string;
    email_de_suporte: string;
    logo: string;
    logo_header?: string | null;
    favicon: string;
    background?: string | null;
    imagem_do_cartao: string;
    imagem_cartao_consignado: string;
    cor_primaria: string;
    cor_secundaria: string;
    api_keys: {
      new_relic_application_id?: string;
      new_relic_license_key?: string;
      new_relic_account_id?: string;
      smartlook_client_key?: string;
      clarity_client_key?: string;
    };
  };
  // Os campos abaixo não são pertinentes para a digitação e portanto são omitidos na tipagem como não obrigatórios para facilitar os mocks
  formalizacao?: {
    titulo: string;
    logo: string;
    favicon: string;
    cor_primaria: string;
    cor_secundaria: string;
    api_keys: {
      unico_project_number: string;
      unico_project_id: string;
      unico_mobile_sdk_app_id: string;
      unico_hostname: string;
      unico_host_info: string;
      unico_host_key: string;
      smartlook_client_key?: string;
      clarity_client_key?: string;
    };
  };
  formalizacao_cartao?: {
    titulo: string;
    logo: string;
    favicon: string;
    cor_primaria: string;
    cor_secundaria: string;
  };
  banners?: Array<{
    id: string;
    titulo: string;
    url_imagem: string;
    ordem: number;
  }>;
};

export type IApiClientThemeData = {
  origin: string;
};

export const useApiClientTheme = () => {
  return useApiOriginacao<IApiClientThemeResponse, IApiClientThemeData>({
    method: "POST",
    url: "/auth/corban/correspondente/",
  });
};
